export default class SiteMeterValueService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(siteMeterValue, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeterValue`, {
      body: JSON.stringify(siteMeterValue),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeterValue/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/meterManagement/siteMeterValue/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeterValue`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, siteMeterValue, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeterValue/${id}`, {
      body: JSON.stringify(siteMeterValue),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}